module.exports = __webpack_public_path__ + "img/player 1.e69ff00b.png";